<template>
    <Card>
        <p slot="title">排行榜 </p>
        <div slot="extra"> <Button slot="extra" @click.prevent="leader" size="small" type="info" ghost>
          获取排行
        </Button></div>
        <div>
            <Tabs value="name1">
                <TabPane label="极品武器排行榜" name="name5">
<!--                  <p v-for="(item, idx) in leaderboardLst5" :key="idx">
                    {{ ++idx }}: {{ item.name }}: {{ item.realmName }}
                  </p>-->
                  <Space wrap>
                    注意事项：切换就会查询 没变化就等几秒,别给我点太快了。
                    <RadioGroup v-model="equit" type="button" @on-change="equitList" button-style="solid">
                      <Radio label="1">武器</Radio>
                      <Radio label="2">玄端</Radio>
                      <Radio label="3">头冠</Radio>
                      <Radio label="4">项链</Radio>
                      <Radio label="7">戒指</Radio>
                      <Radio label="8">绶佩</Radio>
                      <Radio label="9">绶带</Radio>
                      <Radio label="10">鞜履</Radio>
                    </RadioGroup>
                  </Space>
                  <Select v-model="equiltLevel" @on-change="equitList"  style="width:200px">
                    <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                  <Table stripe :columns="columns" :data="leaderboardLst5"></Table>
                </TabPane>
                <TabPane label="爬塔层数排行榜" name="name8" style="max-height: 424px; overflow: auto">
                  <p v-for="(item, idx) in leaderboardLst8" :key="idx">
                    {{ ++idx }}: {{ item.name }}: {{ item.lockTowerName }}
                  </p>
                </TabPane>
                <TabPane label="财富榜" name="name1">
                  <tag color="error">灵石榜</tag>
                  <p v-for="(item, idx) in leaderboardLst1" :key="idx">
                    {{ ++idx }}: {{ item.name }}: {{ item.coin }}
                  </p>
                  <tag color="warning">金币榜</tag>
                  <p v-for="(item, idx) in leaderboardLst3" :key="idx">
                    {{ ++idx }}: {{ item.name }}: {{ item.money }}
                  </p>
                </TabPane>
<!--                <TabPane label="金币" name="name3"  style="max-height: 424px; overflow: auto">
                  <p v-for="(item, idx) in leaderboardLst3" :key="idx">
                    {{ ++idx }}: {{ item.name }}: {{ item.money }}
                  </p>
                </TabPane>-->
                <TabPane label="世界boss伤害榜(单次)" name="name6" class="boss">
<!--                    <p v-for="(item, idx) in leaderboardLst6" :key="idx">
                        {{ ++idx }}: {{ item.name }}:
                        <span v-for="(k,i) in item.gameCharaLevelBoList" :key="k.oneDamage" :style="{ color: i==0?'transparent':'black',fontSize:  i==0? '30px' : '16px' }">
                            {{++i}}: {{k.name}} {{k.oneDamage}}
                        </span>
                    </p>-->
                  <div v-for="(item, idx) in leaderboardLst6" :key="idx">
                    <div class="margin-bottom-10 margin-top-10" style="font-weight: 700"> {{ ++idx }}: {{ item.name }}:</div>
                    <Table  border highlight-row  no-data-text="无数据"
                            :columns="columns3" :data="item.gameCharaLevelBoList">
                    </Table>
                  </div>
                </TabPane>
                <TabPane label="世界boss伤害榜(总)" name="name7" class="boss">
                  <div v-for="(item, idx) in leaderboardLst7" :key="idx">
                    <div class="margin-bottom-10 margin-top-10" style="font-weight: 700"> {{ ++idx }}: {{ item.name }}:</div>
                    <Table  border align="center" highlight-row  no-data-text="无数据"
                            :columns="columns2" :data="item.gameCharaLevelBoList">
                    </Table>
                  </div>
<!--                    <p v-for="(item, idx) in leaderboardLst7" :key="idx">-->
<!--                        {{ ++idx }}: {{ item.name }}:-->
<!--                        <span v-for="(k,i) in item.gameCharaLevelBoList" :key="k.totalDamage" :style="{ color: i == 0 ?'transparent':'black',fontSize:  i==0? '30px' : '16px' }">-->
<!--                            {{++i}}: {{k.name}} {{k.totalDamage}}-->
<!--                        </span>-->
<!--                    </p>-->

                </TabPane>
                <TabPane label="等级" name="name2" style="max-height: 424px; overflow: auto">
                  <p v-for="(item, idx) in leaderboardLst2" :key="idx">
                    {{ ++idx }}: {{ item.name }}: {{ item.level }}
                  </p>
                </TabPane>
            </Tabs>
        </div>
    </Card>
</template>

<script>
export default {
    name: "rankingList",
    data() {
        return {
            equit: 1,
            equiltLevel: 70,
            leaderboardLst1: [], // 灵石排行榜列表
            leaderboardLst2: [], // 等级排行榜列表
            leaderboardLst3: [], // 金币排行榜列表
            leaderboardLst4: [], // 天榜排行榜列表
            leaderboardLst5: [], // 地榜排行榜列表 改为极品武器排行榜
            leaderboardLst6: [], // 世界boss伤害(单次)排行榜列表
            leaderboardLst7: [], // 世界boss伤害(总)排行榜列表
            leaderboardLst8: [], // 爬塔层数排行榜
            cityList: [
              {
                value: '70',
                label: '70'
              },
              {
                value: '65',
                label: '65'
              },
              {
                value: '60',
                label: '60'
              },
              {
                value: '55',
                label: '55'
              },
              {
                value: '50',
                label: '50'
              },
              {
                value: '45',
                label: '45'
              },
              {
                value: '40',
                label: '40'
              }
            ],
            columns2: [
            {
              title: '总伤害',
              key: 'totalDamage'
            },
            {
              title: '玩家',
              key: 'name',
              render: (h, params) => {
                let name=params.row.name;
                let color="green";
                if(params.index<3){
                  color= "red";
                }else if(params.index<10){
                  color= "#ff8c00";
                }else if(params.index<25){
                  color= "purple";
                }else if(params.index<50){
                  color= "blue";
                }
                return h('div', [
                  h('p',{
                    style: {
                      color: color
                    }
                  }, name),
                ]);
              },
            },
            {
              title: '境界',
              key: 'realmName'
            },
            {
              title: '物攻',
              width: 80,
              key: 'attack'
            },
            {
              title: '法攻',
              width: 80,
              key: 'magic'
            },
             {
               title: '奖励',
               width: 180,
               key: 'magic',
               render: (h, params) => {
                 let name="";
                 if(params.row.monType !== 1){
                   name="☪贡献点: 6 \n『中品宗门手札』(内含不少灵石以及洗练石)";
                 }else{
                   name="☯黑山令*8";
                 }
                 let color="green";
                 if(params.index<3){
                   if(params.row.monType !== 1){
                     name="☪贡献点: 12 \n『完美宗门手札』(内含大量灵石以及洗练石)";
                   }else{
                     name="☯黑山令*16";
                   }
                   color= "red";
                 }else if(params.index<10){
                   if(params.row.monType !== 1){
                     name="☪贡献点: 10 \n『破级宗门手札』(内含足量灵石以及洗练石)";
                   }else{
                     name="☯黑山令*14";
                   }
                   color= "#ff8c00";
                 }else if(params.index<25){
                   if(params.row.monType !== 1){
                     name="☪贡献点: 9 \n『优良宗门手札』(内含灵石以及洗练石)";
                   }else{
                     name="☯黑山令*12";
                   }
                   color= "purple";
                 }else if(params.index<50){
                   if(params.row.monType !== 1){
                     name="☪贡献点: 7 \n『上品宗门手札』(内含灵石以及洗练石)";
                   }else{
                     name="☯黑山令*10";
                   }
                   color= "blue";
                 }
                 return h('div', [
                   h('p',{
                     style: {
                       color: color
                     }
                   }, name),
                   // h('Tag',{
                   //   props: {
                   //     color: color
                   //   }
                   // }, name),
                 ]);
               },
             }
          ],
          columns3: [
            {
              title: '单次伤害',
              key: 'oneDamage'
            },
            {
              title: '玩家',
              key: 'name'
            },
            {
              title: '境界',
              key: 'realmName'
            },
            {
              title: '物攻',
              key: 'attack'
            },
            {
              title: '法攻',
              key: 'magic'
            }
          ],
            columns: [
              {
                title: '武器名称',
                width:150,
                key: 'name',
                render: (h, params) => {
                  let name=params.row.name;
                  let color="success";
                  if(params.index<3){
                    color= "error";
                  }else if(params.index<10){
                    color= "warning";
                  }else if(params.index<30){
                    color= "primary";
                  }
                  return h('div', [
                    h('Tag',{
                      props: {
                        color: color,
                        type:"border"
                      }}, "Lv:"+params.row.level),
                    h('Tag',{
                      props: {
                        color: color
                      }
                    }, name),
                  ]);
                },
              },
              {
                title: '所属人',
                key: 'roleName'
              },
              {
                title: '总分',
                key: 'total'
              },
              {
                title: '洗练评分',
                key: 'appraisalScore'
              },
              {
                title: '附加品阶',
                key: 'pinJie'
              },
              {
                title: '强化幅度',
                key: 'enRange',
                render: (h, params) => {
                  let ran="无";
                  if(params.row.enRange){
                    ran=(params.row.enRange * 100).toFixed(0)+"%";
                  }
                  return h('Tag',{
                    props: {
                      color: "#FFA2D3"
                    }
                  },ran);
                }
              }
            ],
        };
    },
    created() {
        setInterval(() => {
            this.leader();
        }, 10000000);
    },
    methods: {
        // 列表
        leader() {
            // 灵石排行榜
            this.$http.get("/gamepassport/coinRanking").then((res) => {
                this.leaderboardLst1 = res.data.data;
            });
            // 等级排行榜
            this.$http.get("/gamepassport/levelRanking").then((res) => {
                this.leaderboardLst2 = res.data.data;
            });
            // 金币排行榜
            this.$http.get("/gamepassport/moneyRanking").then((res) => {
                this.leaderboardLst3 = res.data.data;
            });
            // 天榜排行榜
            this.$http.get("/gamepassport/realmHeavenList").then((res) => {
                this.leaderboardLst4 = res.data.data;
            });
            // 极品武器
           /* this.$http.get("/gamepassport/realmLandList").then((res) => {
                this.leaderboardLst5 = res.data.data;
            });*/
            this.$http.get("/gamepassport/realmLandList?equitType="+this.equit
              +"&level="+this.equiltLevel
            ).then((res) => {
              this.leaderboardLst5 = res.data.data;
            });
            // 世界boss伤害榜(单次)
            this.$http.get("/gamepassport/oneDamageRanking").then((res) => {
                this.leaderboardLst6 = res.data.data;
            });
            // 世界boss伤害榜(总)
            this.$http.get("/gamepassport/totalDamageRanking").then((res) => {
                this.leaderboardLst7 = res.data.data;
            });
            // 爬塔层数排行榜
            this.$http.get("/gamepassport/totwerNumList").then((res) => {
              this.leaderboardLst8 = res.data.data;
            });
        },
      equitList(){
        // 极品武器
        this.$http.get("/gamepassport/realmLandList?equitType="+this.equit
          +"&level="+this.equiltLevel
        ).then((res) => {
          this.leaderboardLst5 = res.data.data;
        });
      }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.boss p span {
    margin-left: 20px;
    display: block;

    background-image: linear-gradient(45deg, #ff6b6b, #8b78e6, #51cf66);
    -webkit-background-clip: text;
    text-align: center;
    font-size: 36px;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/rankingList.vue